import { DropdownSkeleton } from "../dropdown/dropdown.skeleton";

export const DropdownCoachSkeleton = () => {
	return <DropdownSkeleton />;
};
